// extracted by mini-css-extract-plugin
export default {"steps":"kC-z","header":"lC-z","description":"mC-z"};